import cx from "classnames";
import { Text } from "@theorgchartdev/storybook";

const FileTextRow = ({ rowState, isSelected }) => {
  let data = rowState?.data;
  let colIdx = rowState.colIndex;
  let label = colIdx === 1 ? data.type : data.localModTime;
  let baseClass = "ocn-file-row";
  let activeClass = isSelected ? `ocn-file-row-active` : null;
  let noTextSelection = "oc-no-text-select";
  return (
    <span className={cx(baseClass, activeClass, noTextSelection)} title={label}>
      <Text size={"small"}>{label}</Text>
    </span>
  );
};

export default FileTextRow;
